import React, { useState } from 'react';

// Sample job openings data
const jobOpenings = [
  { title: "Structural Engineer", exp: "3-5 yrs", code: "SE2025" },
  { title: "Project Manager", exp: "5-8 yrs", code: "PM2025" },
  { title: "Site Supervisor", exp: "2-4 yrs", code: "SS2025" },
  { title: "Design Drafter", exp: "1-3 yrs", code: "DD2025" },
  { title: "Quality Analyst", exp: "2-5 yrs", code: "QA2025" },
  { title: "Purchase Executive", exp: "1-2 yrs", code: "PE2025" },
  { title: "Marketing Lead", exp: "4-6 yrs", code: "ML2025" },
  { title: "Safety Officer", exp: "2-4 yrs", code: "SO2025" },
  { title: "Production Engineer", exp: "3-5 yrs", code: "PE2025" },
  { title: "Accounts Executive", exp: "2-3 yrs", code: "AE2025" },
  { title: "Project Coordinator", exp: "3-5 yrs", code: "PC2025" },
];

function Carrer() {
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
  });
  const [submitted, setSubmitted] = useState(false);

  const openModal = (job) => {
    setSelectedJob(job);
    setShowModal(true);
    setSubmitted(false);
    setForm({ name: "", email: "", phone: "", resume: null });
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedJob(null);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Here you can add your backend integration
  };

  return (
    <div style={{ padding: "2rem" }}>
      <style>{`
        .career-table {
          width: 100%;
          max-width: 900px;
          margin: 0 auto 2rem auto;
          border-collapse: collapse;
          font-family: 'Josefin Sans', Sans-serif;
          background: #fff;
          box-shadow: 0 2px 8px rgba(19,73,156,0.08);
        }
        .career-table th, .career-table td {
          border: 1px solid #e0e0e0;
          padding: 0.75rem 1rem;
          text-align: center;
        }
        .career-table th {
          background: #13499C;
          color: #fff;
          font-weight: 700;
        }
        .career-table tr:nth-child(even) {
          background: #f7faff;
        }
        .apply-btn {
          background: #13499C;
          color: #fff;
          border: none;
          padding: 0.5rem 1.2rem;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.2s;
        }
        .apply-btn:hover {
          background: #0e3570;
        }
        .modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal-content {
          background: #fff;
          padding: 2rem 1.5rem;
          border-radius: 8px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 4px 24px rgba(19,73,156,0.12);
          position: relative;
        }
        .modal-close {
          position: absolute;
          top: 10px; right: 16px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #13499C;
        }
        @media (max-width: 700px) {
          .career-table th, .career-table td {
            padding: 0.5rem;
            font-size: 0.95rem;
          }
          .modal-content {
            padding: 1rem 0.5rem;
          }
        }
      `}</style>
      <h2 style={{
        textAlign: "center",
        marginBottom: "3rem",
        color: "#13499C",
        fontFamily: '"Josefin Sans", Sans-serif'
      }}>
        Careers
      </h2>
      <table className="career-table">
        <thead>
          <tr>
            <th>SNo</th>
            <th>Job Title</th>
            <th>Exp</th>
            <th>JobCode</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {jobOpenings.map((job, idx) => (
            <tr key={job.code}>
              <td>{idx + 1}</td>
              <td>{job.title}</td>
              <td>{job.exp}</td>
              <td>{job.code}</td>
              <td>
                <button className="apply-btn" onClick={() => openModal(job)}>
                  Apply
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModal && selectedJob && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <h3 style={{color: "#13499C", marginBottom: "1rem"}}>Apply for {selectedJob.title}</h3>
            <p><b>Experience:</b> {selectedJob.exp}</p>
            <p><b>Job Code:</b> {selectedJob.code}</p>
            {submitted ? (
              <div style={{ color: "green", fontWeight: 600, marginTop: 20 }}>
                Thank you for applying!
              </div>
            ) : (
            <form onSubmit={handleSubmit}>
              <div style={{marginBottom: "1rem"}}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  style={{width: "100%", padding: "0.5rem"}}
                />
              </div>
              <div style={{marginBottom: "1rem"}}>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  style={{width: "100%", padding: "0.5rem"}}
                />
              </div>
              <div style={{marginBottom: "1rem"}}>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  style={{width: "100%", padding: "0.5rem"}}
                />
              </div>
              <div style={{marginBottom: "1rem"}}>
                <input
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  required
                  style={{width: "100%"}}
                />
              </div>
              <button type="submit" className="apply-btn" style={{width: "100%"}}>
                Submit Application
              </button>
            </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Carrer;
